"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconCaptions = void 0;
var React = __importStar(require("react"));
var IconCaptions = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#464650", fillRule: "evenodd", d: "M16.254,15.659 C13.473,15.659 12.41,13.858 12.41,12.054 C12.41,10.222 13.598,8.328 16.254,8.328 C17.246,8.328 18.145,8.691 18.891,9.422 L17.727,10.465 C17.328,10.091 16.785,9.92 16.254,9.92 C14.711,9.92 14.149,11.134 14.149,12.057 C14.149,12.977 14.641,13.971 16.254,13.971 C16.785,13.971 17.43,13.738 17.828,13.345 L19.035,14.62 C18.402,15.226 17.336,15.659 16.254,15.659 L16.254,15.659 Z M8.789,15.659 C6.008,15.659 4.945,13.858 4.945,12.054 C4.945,10.222 6.133,8.328 8.789,8.328 C9.781,8.328 10.68,8.691 11.426,9.422 L10.262,10.465 C9.863,10.091 9.32,9.92 8.789,9.92 C7.246,9.92 6.684,11.134 6.684,12.057 C6.684,12.977 7.176,13.971 8.789,13.971 C9.32,13.971 9.965,13.738 10.363,13.345 L11.57,14.62 C10.938,15.226 9.875,15.659 8.789,15.659 L8.789,15.659 Z M22,5.998 C22,4.892 21.098,4 19.984,4 L4.024,4 C2.91,4 2,4.892 2,5.998 L2,18.009 C2,19.114 2.91,20 4.024,20 L19.981,20 C21.098,20 21.996,19.114 21.996,18.009 L21.996,5.998 L22,5.998 Z" }))); };
exports.IconCaptions = IconCaptions;
exports.IconCaptions.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconCaptions;
